export interface User {
  id: string;
  uid: string;
  firstName: string;
  lastName: string;
  email: string;
  displayName?: string;
  nickname?: string;
  team?: string;
  city?: string;
  role: 'bronze' | 'silver' | 'gold' | 'admin';
  verified: boolean;
  createdAt: string;
  parentId?: string;
  isChild?: boolean;
  notificationsEnabled?: boolean;
}

// Types d'adhérents et leurs permissions
export const MEMBER_TYPES = {
  BRONZE: 'bronze',  // Événements en salles communales uniquement
  SILVER: 'silver',  // Événements en salles communales uniquement
  GOLD: 'gold',     // Tous les événements (y compris à domicile)
  ADMIN: 'admin'    // Accès complet + gestion
} as const;

// Descriptions des types d'adhérents
export const MEMBER_TYPE_DESCRIPTIONS = {
  [MEMBER_TYPES.BRONZE]: 'Accès aux événements en salles communales',
  [MEMBER_TYPES.SILVER]: 'Accès aux événements en salles communales',
  [MEMBER_TYPES.GOLD]: 'Accès à tous les événements (y compris à domicile)',
  [MEMBER_TYPES.ADMIN]: 'Accès administrateur complet'
} as const;
